import React from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import useLoginForm from '../../hooks/useLoginForm';
import backgroundImage from '../../assets/img/fondoUno.png';
import UCPlogo from '../../assets/img/logoUCP2.png';

function Login() {
  const {
    credentials,
    showPassword,
    error,
    handleChange,
    togglePasswordVisibility,
    handleSubmit
  } = useLoginForm();

  return (
    <div className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="bg-white p-8 rounded-lg shadow-md w-96">
        <div className="flex mb-4">
          <img src={UCPlogo} alt="UCP Logo" className="h-28 w-auto" />
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <h1 className="text-2xl font-extrabold font-montserrat mb-4">Iniciar sesión</h1>
          {error && <p className="text-red-500">{error}</p>}

          <div className="flex items-center mb-4">
            <div className="flex-grow h-1 rounded bg-green-700"></div>
            <span className="px-2 text-green-700 font-montserrat font-bold">IDENTIDAD INSTITUCIONAL</span>
          </div>

          <div className="relative">
            <strong>Correo:</strong>
            <input
              type="email"
              name="correo"
              value={credentials.correo}
              onChange={handleChange}
              placeholder="universidadcatolica@ucp.edu.co"
              required
              className="w-full p-2 border rounded"
            />
          </div>

          <div className="relative">
            <strong>Contraseña:</strong>
            <input
              type={showPassword ? "text" : "password"}
              name="contrasena"
              value={credentials.contrasena}
              onChange={handleChange}
              placeholder="••••••••••"
              required
              className="w-full p-2 pr-10 border rounded"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute right-3 top-[65%] transform -translate-y-1/2 text-black"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button type="submit" className="w-full font-bold bg-green-700 text-white p-2 rounded hover:bg-green-600">
            INGRESAR
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;